<template>
  <div class="lead-management">
    <!-- 查询条件区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="searchForm" label-width="100px" class="search-form">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="意向车型">
              <el-select 
                v-model="searchForm.intendedVehicle" 
                placeholder="请选择意向车型" 
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in carModelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="线索状态">
              <el-select 
                class="lead_opt"
                v-model="searchForm.leadStatus" 
                placeholder="请选择线索状态" 
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in LEAD_STATUS_OPTIONS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="是否有效">
              <el-select 
                v-model="searchForm.isValid" 
                placeholder="请选择是否有效" 
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in VALID_OPTIONS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="线索来源">
              <el-select 
                v-model="searchForm.leadSource" 
                placeholder="请选择线索来源" 
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in LEAD_SOURCE_OPTIONS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="手机号">
              <el-input 
                v-model="searchForm.phone" 
                placeholder="请输入手机号" 
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="24" class="search-buttons">
            <el-button type="primary" @click="handleSearch" :icon="Search">查询</el-button>
            <el-button @click="handleReset" :icon="RefreshLeft">清空</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 数据列表区域 -->
    <el-card class="table-card" shadow="never">
      <!-- 操作工具栏 -->
      <div class="table-toolbar">
        <el-button type="primary" :icon="Plus" @click="handleCreate">新增线索</el-button>
      </div>

      <el-table 
        :data="tableData" 
        style="width: 100%" 
        stripe
        v-loading="loading"
      >
        <el-table-column prop="leadNo" label="线索编号" min-width="160" />
        
        <el-table-column label="意向车型" min-width="120" show-overflow-tooltip>
          <template #default="{ row }">
            {{ getCarModelLabel(row.intendedVehicle) }}
          </template>
        </el-table-column>
        
        <el-table-column label="线索状态" min-width="110">
          <template #default="{ row }">
            <el-select 
              v-model="row.leadStatus" 
              @change="handleStatusChange(row, $event)"
              @focus="saveOldValue(row, 'leadStatus')"
              size="small"
              :class="['status-select', getStatusClass(row.leadStatus)]"
              popper-class="status-select-dropdown"
            >
              <el-option
                v-for="item in LEAD_STATUS_OPTIONS"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <div :class="['status-option', getStatusClass(item.value)]">{{ item.label }}</div>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        
        <el-table-column prop="phone" label="手机号" min-width="120" />
        
        <el-table-column label="是否有效" min-width="90">
          <template #default="{ row }">
            <el-select 
              v-model="row.isValid" 
              @change="handleValidChange(row, $event)"
              @focus="saveOldValue(row, 'isValid')"
              size="small"
              :class="['valid-select', getValidClass(row.isValid)]"
              popper-class="valid-select-dropdown"
            >
              <el-option
                v-for="item in VALID_OPTIONS"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <div :class="['valid-option', getValidClass(item.value)]">{{ item.label }}</div>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        
        <el-table-column label="线索来源" min-width="90">
          <template #default="{ row }">
            <el-select 
              v-model="row.leadSource" 
              @change="handleSourceChange(row, $event)"
              @focus="saveOldValue(row, 'leadSource')"
              size="small"
              :class="['source-select', getSourceClass(row.leadSource)]"
              popper-class="source-select-dropdown"
            >
              <el-option
                v-for="item in LEAD_SOURCE_OPTIONS"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <div :class="['source-option', getSourceClass(item.value)]">{{ item.label }}</div>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        
        <el-table-column prop="followUpPerson" label="跟进人" min-width="80" />
        
        <el-table-column label="备注" min-width="130">
          <template #default="{ row }">
            <el-tooltip
              :content="row.remark"
              placement="top"
              :disabled="!row.remark"
              popper-class="remark-tooltip"
            >
              <div class="ellipsis-cell">{{ row.remark }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button 
              type="primary" 
              link 
              size="small" 
              @click="handleDetail(row)"
              :icon="View"
            >
              详情
            </el-button>
            <el-button 
              type="primary" 
              link 
              size="small" 
              @click="handleEdit(row)"
              :icon="Edit"
            >
              修改
            </el-button>
            <!-- <el-button 
              type="danger" 
              link 
              size="small" 
              @click="handleDelete(row)"
              :icon="Delete"
            >
              删除
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          v-model:current-page="pagination.currentPage"
          v-model:page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增线索弹窗 -->
    <el-dialog
      v-model="createDialogVisible"
      title="新增线索"
      width="600px"
      @closed="resetCreateForm"
    >
      <el-form
        :model="createForm"
        :rules="createRules"
        ref="createFormRef"
        label-width="100px"
      >
        <el-form-item label="意向车型" prop="intendedVehicle">
          <el-select 
            v-model="createForm.intendedVehicle" 
            placeholder="请选择意向车型"
            clearable
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="item in carModelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="createForm.phone" placeholder="请输入线索人手机号" maxlength="11" />
        </el-form-item>
        <el-form-item label="线索状态" prop="leadStatus">
          <el-select v-model="createForm.leadStatus" placeholder="请选择线索状态" style="width: 100%">
            <el-option
              v-for="item in LEAD_STATUS_OPTIONS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否有效" prop="isValid">
          <el-select v-model="createForm.isValid" placeholder="请选择是否有效" style="width: 100%">
            <el-option
              v-for="item in VALID_OPTIONS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="线索来源" prop="leadSource">
          <el-select v-model="createForm.leadSource" placeholder="请选择线索来源" style="width: 100%">
            <el-option
              v-for="item in LEAD_SOURCE_OPTIONS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="跟进人" prop="followUpPerson">
          <el-input 
            v-model="createForm.followUpPerson" 
            placeholder="请输入跟进运营人员" 
            maxlength="5"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="createForm.remark"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 10 }"
            placeholder="请输入备注信息"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="createLoading" @click="handleCreateSubmit">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'LeadManagement'
}
</script>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, RefreshLeft, View, Edit, Plus } from '@element-plus/icons-vue'
import { getLeadPoolPage, updateLeadPool, createLeadPool } from '@/api/leadPool'
import { getBrandCarModeList } from '@/api/city'
import {
  LEAD_STATUS_OPTIONS,
  VALID_OPTIONS,
  LEAD_SOURCE_OPTIONS,
  getLabel
} from '@/constants/leadPool'

const router = useRouter()

// 品牌列表
const brandCarModeList = ref([])

// 车型选项列表（拼凑后的）
const carModelOptions = ref([])

// 查询表单
const searchForm = reactive({
  intendedVehicle: '',
  leadStatus: '',
  isValid: '',
  leadSource: '',
  phone: ''
})

// 表格数据
const tableData = ref([])
const loading = ref(false)

// 分页
const pagination = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0
})

// 保存旧值的临时存储
const oldValues = reactive({})

// 保存旧值
const saveOldValue = (row, field) => {
  const key = `${row.id}_${field}`
  if (!oldValues[key]) {
    oldValues[key] = row[field]
  }
}

// 获取数据
const fetchData = async () => {
  loading.value = true

  const params = {
    pageNum: pagination.currentPage,
    pageSize: pagination.pageSize,
    intendedVehicle: searchForm.intendedVehicle || undefined,
    leadStatus: searchForm.leadStatus || undefined,
    isValid: searchForm.isValid || undefined,
    leadSource: searchForm.leadSource || undefined,
    phone: searchForm.phone || undefined
  }

  try {
    const res = await getLeadPoolPage(params)
    const page = res.data || {}
    tableData.value = page.records || []
    pagination.total = page.total || 0
  } catch (error) {
    console.error('查询线索列表失败：', error)
  } finally {
    loading.value = false
  }
}

// 查询
const handleSearch = () => {
  pagination.currentPage = 1
  fetchData()
}

// 重置
const handleReset = () => {
  searchForm.intendedVehicle = ''
  searchForm.leadStatus = ''
  searchForm.isValid = ''
  searchForm.leadSource = ''
  searchForm.phone = ''
  pagination.currentPage = 1
  fetchData()
}

// 调用接口更新线索单个字段
const updateLeadField = async (row, field, newValue) => {
  await updateLeadPool({
    id: row.id,
    intendedVehicle: row.intendedVehicle,
    leadStatus: row.leadStatus,
    phone: row.phone,
    followUpPerson: row.followUpPerson,
    isValid: row.isValid,
    leadSource: row.leadSource,
    remark: row.remark,
    [field]: newValue
  })
}

// 线索状态变更
const handleStatusChange = (row, newValue) => {
  const key = `${row.id}_leadStatus`
  const oldStatus = oldValues[key]

  // 立即恢复旧值，等待用户确认
  row.leadStatus = oldStatus

  ElMessageBox.confirm(
    `<div style="line-height: 1.8;">
      <div><strong>线索编号：</strong>${row.leadNo}</div>
      <div><strong>变更目标：</strong>线索状态</div>
      <div><strong>从</strong> ${getLabel(LEAD_STATUS_OPTIONS, oldStatus)} <strong>=></strong> ${getLabel(LEAD_STATUS_OPTIONS, newValue)}</div>
    </div>`,
    '确认变更',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(async () => {
    try {
      await updateLeadField(row, 'leadStatus', newValue)
      row.leadStatus = newValue
      oldValues[key] = newValue
      ElMessage.success(`线索 ${row.leadNo} 状态已更新为：${getLabel(LEAD_STATUS_OPTIONS, newValue)}`)
    } catch (error) {
      console.error('更新线索状态失败：', error)
    }
  }).catch(() => {
    ElMessage.info('已取消变更')
  })
}

// 是否有效变更
const handleValidChange = (row, newValue) => {
  const key = `${row.id}_isValid`
  const oldValid = oldValues[key]

  // 立即恢复旧值，等待用户确认
  row.isValid = oldValid

  ElMessageBox.confirm(
    `<div style="line-height: 1.8;">
      <div><strong>线索编号：</strong>${row.leadNo}</div>
      <div><strong>变更目标：</strong>是否有效</div>
      <div><strong>从</strong> ${getLabel(VALID_OPTIONS, oldValid)} <strong>=></strong> ${getLabel(VALID_OPTIONS, newValue)}</div>
    </div>`,
    '确认变更',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(async () => {
    try {
      await updateLeadField(row, 'isValid', newValue)
      row.isValid = newValue
      oldValues[key] = newValue
      ElMessage.success(`线索 ${row.leadNo} 有效性已更新为：${getLabel(VALID_OPTIONS, newValue)}`)
    } catch (error) {
      console.error('更新线索有效性失败：', error)
    }
  }).catch(() => {
    ElMessage.info('已取消变更')
  })
}

// 线索来源变更
const handleSourceChange = (row, newValue) => {
  const key = `${row.id}_leadSource`
  const oldSource = oldValues[key]

  // 立即恢复旧值，等待用户确认
  row.leadSource = oldSource

  ElMessageBox.confirm(
    `<div style="line-height: 1.8;">
      <div><strong>线索编号：</strong>${row.leadNo}</div>
      <div><strong>变更目标：</strong>线索来源</div>
      <div><strong>从</strong> ${getLabel(LEAD_SOURCE_OPTIONS, oldSource)} <strong>=></strong> ${getLabel(LEAD_SOURCE_OPTIONS, newValue)}</div>
    </div>`,
    '确认变更',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(async () => {
    try {
      await updateLeadField(row, 'leadSource', newValue)
      row.leadSource = newValue
      oldValues[key] = newValue
      ElMessage.success(`线索 ${row.leadNo} 来源已更新为：${getLabel(LEAD_SOURCE_OPTIONS, newValue)}`)
    } catch (error) {
      console.error('更新线索来源失败：', error)
    }
  }).catch(() => {
    ElMessage.info('已取消变更')
  })
}

// 查看详情
const handleDetail = (row) => {
  router.push({
    path: '/home/articles/detail',
    query: {
      id: row.id,
      mode: 'detail'
    }
  })
}

// 编辑
const handleEdit = (row) => {
  router.push({
    path: '/home/articles/detail',
    query: {
      id: row.id,
      mode: 'edit'
    }
  })
}

// ========== 新增线索 ==========
const createDialogVisible = ref(false)
const createLoading = ref(false)
const createFormRef = ref(null)
const createForm = reactive({
  intendedVehicle: '',
  phone: '',
  leadStatus: '',
  isValid: '',
  leadSource: '',
  followUpPerson: '',
  remark: ''
})

const createRules = {
  intendedVehicle: [
    { required: true, message: '请选择意向车型', trigger: 'change' }
  ],
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
  ],
  leadStatus: [
    { required: true, message: '请选择线索状态', trigger: 'change' }
  ],
  isValid: [
    { required: true, message: '请选择是否有效', trigger: 'change' }
  ],
  leadSource: [
    { required: true, message: '请选择线索来源', trigger: 'change' }
  ],
  followUpPerson: [
    { required: true, message: '请输入跟进人', trigger: 'blur' }
  ]
}

const handleCreate = () => {
  createDialogVisible.value = true
}

const resetCreateForm = () => {
  createForm.intendedVehicle = ''
  createForm.phone = ''
  createForm.leadStatus = ''
  createForm.isValid = ''
  createForm.leadSource = ''
  createForm.followUpPerson = ''
  createForm.remark = ''
  createFormRef.value && createFormRef.value.clearValidate()
}

const handleCreateSubmit = () => {
  createFormRef.value.validate(async (valid) => {
    if (!valid) return
    createLoading.value = true
    try {
      await createLeadPool({ ...createForm })
      ElMessage.success('新增成功')
      createDialogVisible.value = false
      pagination.currentPage = 1
      fetchData()
    } catch (error) {
      console.error('新增线索失败：', error)
    } finally {
      createLoading.value = false
    }
  })
}

// ========== 删除线索 ==========
// const handleDelete = (row) => {
//   ElMessageBox.confirm(
//     `确认删除线索「${row.leadNo}」吗？删除后不可恢复。`,
//     '删除确认',
//     {
//       confirmButtonText: '确认删除',
//       cancelButtonText: '取消',
//       type: 'warning'
//     }
//   ).then(async () => {
//     try {
//       await deleteLeadPool(row.id)
//       ElMessage.success('删除成功')
//       // 若当前页删空且非第一页，则回退一页
//       if (tableData.value.length === 1 && pagination.currentPage > 1) {
//         pagination.currentPage--
//       }
//       fetchData()
//     } catch (error) {
//       console.error('删除线索失败：', error)
//     }
//   }).catch(() => {})
// }

// 分页大小变更
const handleSizeChange = (val) => {
  pagination.pageSize = val
  fetchData()
}

// 当前页变更
const handleCurrentChange = (val) => {
  pagination.currentPage = val
  fetchData()
}

// 全局回车触发查询（无需聚焦输入框）
const handleEnterKey = (e) => {
  if (e.key === 'Enter') {
    handleSearch()
  }
}

// 加载品牌列表
const loadBrandCarModeList = async () => {
  try {
    const res = await getBrandCarModeList()
    if (res.code === 200 && res.success) {
      brandCarModeList.value = res.data || []
      
      // 处理车型选项：将品牌名称和车型名称拼凑
      carModelOptions.value = []
      brandCarModeList.value.forEach(brand => {
        if (brand.carModel && Array.isArray(brand.carModel)) {
          brand.carModel.forEach(model => {
            carModelOptions.value.push({
              label: `${brand.brandName} ${model.modelName}`,  // 显示：乐道 L60
              value: model.modelName,  // 查询值：L60
              brandName: brand.brandName,
              brandCode: brand.brandCode,
              modelImage: model.modelImage
            })
          })
        }
      })
      console.log('车型选项列表：', carModelOptions.value)
    }
  } catch (error) {
    console.error('获取品牌列表失败：', error)
  }
}

// 根据车型modelName获取完整显示名称（品牌+车型）
const getCarModelLabel = (modelName) => {
  if (!modelName) return ''
  const carModel = carModelOptions.value.find(item => item.value === modelName)
  return carModel ? carModel.label : modelName
}

// 初始化
onMounted(() => {
  loadBrandCarModeList()
  fetchData()
  window.addEventListener('keyup', handleEnterKey)
})

onUnmounted(() => {
  window.removeEventListener('keyup', handleEnterKey)
})

// 获取状态对应的类名
const getStatusClass = (status) => {
  const statusMap = {
    'PENDING_COMMUNICATION': 'status-pending',
    'INVITED': 'status-invited',
    'TEST_DRIVED': 'status-tested',
    'ORDERED': 'status-ordered',
    'COMPLETED': 'status-completed',
    'DEFEATED': 'status-failed'
  }
  return statusMap[status] || ''
}

// 获取有效性对应的类名
const getValidClass = (isValid) => {
  return isValid === 'VALID' ? 'valid-yes' : 'valid-no'
}

// 获取线索来源对应的类名
const getSourceClass = (leadSource) => {
  return leadSource === 'PRIVATE' ? 'source-private' : 'source-public'
}
</script>

<style scoped>
.lead-management {
  padding: 0;
}



.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
}

.search-form {
  padding: 10px 0;
}

.search-buttons {
  text-align: right;
  padding-right: 10px;
}

.table-card {
  border-radius: 8px;
}

:deep(.el-card__body) {
  padding: 20px;
}

:deep(.el-form-item) {
  margin-bottom: 16px;
}

/* 线索状态样式 */
.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

/* 下拉选项样式 - 占满整个选项宽度 */
.status-option {
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  box-sizing: border-box;
  color: #333333;
}

.status-pending {
  background-color: #F2F2F2;
}

.status-invited {
  background-color: #FFEBBC;
}

.status-tested {
  background-color: #2BC3FF;
}

.status-ordered {
  background-color: #2EFFD3;
}

.status-completed {
  background-color: #FFC561;
}

.status-failed {
  background-color: #FF7C7C;
}

/* 是否有效样式 */
.valid-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

/* 下拉选项样式 - 占满整个选项宽度 */
.valid-option {
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  box-sizing: border-box;
}

.valid-no {
  background-color: #606266;
  color: #fff;
}

.valid-yes {
  background-color: #fde2e2;
  color: #f56c6c;
}

/* 线索来源样式 */
.source-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

/* 下拉选项样式 - 占满整个选项宽度 */
.source-option {
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  box-sizing: border-box;
  color: #333333;
}

.source-private {
  background-color: #F2F2F2;
}

.source-public {
  background-color: #F2F2F2;
}
/* 表格内的下拉框样式优化 */
:deep(.el-table .el-select) {
  width: 100%;
}

:deep(.el-table .el-select .el-input__wrapper) {
  box-shadow: none !important;
  padding: 0 !important;
  border: none !important;
}

:deep(.el-table .el-select .el-input__inner) {
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-weight: 500;
  font-size: 13px;
}

/* 移除 suffix 图标的背景 */
:deep(.el-table .el-select .el-input__suffix) {
  background-color: transparent !important;
}

/* 线索状态 - 待沟通 */
:deep(.status-select.status-pending .el-input__wrapper) {
  background-color: #F2F2F2 !important;
}

:deep(.status-select.status-pending .el-input__inner) {
  color: #333333 !important;
}

/* 线索状态 - 已邀约 */
:deep(.status-select.status-invited .el-input__wrapper) {
  background-color: #FFEBBC !important;
}

:deep(.status-select.status-invited .el-input__inner) {
  color: #333333 !important;
}

/* 线索状态 - 已试驾 */
:deep(.status-select.status-tested .el-input__wrapper) {
  background-color: #2BC3FF !important;
}

:deep(.status-select.status-tested .el-input__inner) {
  color: #333333 !important;
}

/* 线索状态 - 已下定 */
:deep(.status-select.status-ordered .el-input__wrapper) {
  background-color: #2EFFD3 !important;
}

:deep(.status-select.status-ordered .el-input__inner) {
  color: #333333 !important;
}

/* 线索状态 - 已成交 */
:deep(.status-select.status-completed .el-input__wrapper) {
  background-color: #FFC561 !important;
}

:deep(.status-select.status-completed .el-input__inner) {
  color: #333333 !important;
}

/* 线索状态 - 战败 */
:deep(.status-select.status-failed .el-input__wrapper) {
  background-color: #FF7C7C !important;
}

:deep(.status-select.status-failed .el-input__inner) {
  color: #333333 !important;
}

/* 是否有效 - 无效 */
:deep(.valid-select.valid-no .el-input__wrapper) {
  background-color: #606266 !important;
}

:deep(.valid-select.valid-no .el-input__inner) {
  color: #fff !important;
}

/* 是否有效 - 有效 */
:deep(.valid-select.valid-yes .el-input__wrapper) {
  background-color: #fde2e2 !important;
}

:deep(.valid-select.valid-yes .el-input__inner) {
  color: #f56c6c !important;
}

/* 线索来源 - 私域 */
:deep(.source-select.source-private .el-input__wrapper) {
  background-color: #F2F2F2 !important;
}

:deep(.source-select.source-private .el-input__inner) {
  color: #333333 !important;
}

/* 线索来源 - 公域 */
:deep(.source-select.source-public .el-input__wrapper) {
  background-color: #F2F2F2 !important;
}

:deep(.source-select.source-public .el-input__inner) {
  color: #333333 !important;
}


/* 分页容器 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  :deep(.el-form--inline .el-form-item) {
    display: block;
    margin-right: 0;
  }
  
  :deep(.el-input),
  :deep(.el-select) {
    width: 100% !important;
  }
}

/* 备注 textarea 字数统计不重叠 */
:deep(.el-textarea .el-input__count) {
  background-color: transparent;
  bottom: 5px;
  right: 10px;
}

:deep(.el-textarea__inner) {
  padding-bottom: 30px !important;
}

/* 单元格省略号样式 - 统一处理 */
.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

</style>

<style>
/* 全局样式 - 用于下拉框弹出层 */
.status-select-dropdown .el-select-dropdown__item,
.valid-select-dropdown .el-select-dropdown__item,
.source-select-dropdown .el-select-dropdown__item {
  padding: 0px  !important;
  height: auto !important;
  line-height: normal !important;
}

.status-select-dropdown .el-select-dropdown__item:hover,
.valid-select-dropdown .el-select-dropdown__item:hover,
.source-select-dropdown .el-select-dropdown__item:hover {
  background-color: transparent !important;
}

.status-select-dropdown .el-select-dropdown__item:hover .status-option,
.valid-select-dropdown .el-select-dropdown__item:hover .valid-option,
.source-select-dropdown .el-select-dropdown__item:hover .source-option {
  opacity: 0.85;
}

/* 备注提示框样式 - 自动换行 */
.remark-tooltip {
  max-width: 15em !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  line-height: 1.6 !important;
}

/* 全局样式 - 确保表格中的选择器背景色生效 */
.el-table .status-select .el-input__wrapper,
.el-table .valid-select .el-input__wrapper,
.el-table .source-select .el-input__wrapper {
  box-shadow: none !important;
  border: none !important;
}

/* 线索状态背景色 - 待沟通 */
.el-table .status-select.status-pending .el-select__wrapper {
  background-color: #F2F2F2 !important;
}

.el-table .status-select.status-pending .el-select__placeholder,
.el-table .status-select.status-pending .el-select__input {
  color: #333333 !important;
}

/* 线索状态背景色 - 已邀约 */
.el-table .status-select.status-invited .el-select__wrapper {
  background-color: #FFEBBC !important;
}

.el-table .status-select.status-invited .el-select__placeholder,
.el-table .status-select.status-invited .el-select__input {
  color: #333333 !important;
}

/* 线索状态背景色 - 已试驾 */
.el-table .status-select.status-tested .el-select__wrapper {
  background-color: #2BC3FF !important;
}

.el-table .status-select.status-tested .el-select__placeholder,
.el-table .status-select.status-tested .el-select__input {
  color: #333333 !important;
}

/* 线索状态背景色 - 已下定 */
.el-table .status-select.status-ordered .el-select__wrapper {
  background-color: #2EFFD3 !important;
}

.el-table .status-select.status-ordered .el-select__placeholder,
.el-table .status-select.status-ordered .el-select__input {
  color: #333333 !important;
}

/* 线索状态背景色 - 已成交 */
.el-table .status-select.status-completed .el-select__wrapper {
  background-color: #FFC561 !important;
}

.el-table .status-select.status-completed .el-select__placeholder,
.el-table .status-select.status-completed .el-select__input {
  color: #333333 !important;
}

/* 线索状态背景色 - 战败 */
.el-table .status-select.status-failed .el-select__wrapper {
  background-color: #FF7C7C !important;
}

.el-table .status-select.status-failed .el-select__placeholder,
.el-table .status-select.status-failed .el-select__input {
  color: #333333 !important;
}

/* 是否有效背景色 - 无效 */
.el-table .valid-select.valid-no .el-select__wrapper {
  background-color: #606266 !important;
}

.el-table .valid-select.valid-no .el-select__placeholder,
.el-table .valid-select.valid-no .el-select__input {
  color: #fff !important;
}

/* 是否有效背景色 - 有效 */
.el-table .valid-select.valid-yes .el-select__wrapper {
  background-color: #fde2e2 !important;
}

.el-table .valid-select.valid-yes .el-select__placeholder,
.el-table .valid-select.valid-yes .el-select__input {
  color: #f56c6c !important;
}

/* 保持箭头为默认颜色（灰色） */
.el-table .status-select .el-select__caret,
.el-table .valid-select .el-select__caret,
.el-table .source-select .el-select__caret {
  color: #333333 !important;
}

/* 线索来源背景色 - 私域 */
.el-table .source-select.source-private .el-select__wrapper {
  background-color: #F2F2F2 !important;
}

.el-table .source-select.source-private .el-select__placeholder,
.el-table .source-select.source-private .el-select__input {
  color: #333333 !important;
}

/* 线索来源背景色 - 公域 */
.el-table .source-select.source-public .el-select__wrapper {
  background-color: #F2F2F2 !important;
}

.el-table .source-select.source-public .el-select__placeholder,
.el-table .source-select.source-public .el-select__input {
  color: #333333 !important;
}

/* 移除选择器的 focus 高亮边框 */
.el-table .status-select .el-select__wrapper.is-focused,
.el-table .valid-select .el-select__wrapper.is-focused,
.el-table .source-select .el-select__wrapper.is-focused,
.el-table .status-select .el-select__wrapper:focus,
.el-table .valid-select .el-select__wrapper:focus,
.el-table .source-select .el-select__wrapper:focus {
  box-shadow: none !important;
  outline: none !important;
}

.el-table .status-select .el-select__wrapper,
.el-table .valid-select .el-select__wrapper,
.el-table .source-select .el-select__wrapper {
  box-shadow: none !important;
}
</style>
